module.exports = __webpack_public_path__ + "static/media/choithramsSaveTimes.f65349ce.png";